import { render, staticRenderFns } from "./IdpReportHeader.vue?vue&type=template&id=78d70698"
import script from "./IdpReportHeader.vue?vue&type=script&lang=js"
export * from "./IdpReportHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports